import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Optional,
  Output,
} from '@angular/core';
import {
  ControlContainer,
  FormControl,
  NG_VALUE_ACCESSOR,
  Validators,
} from '@angular/forms';
import { FieldErrorStateMatcher } from './error-state-matcher';

export interface PasswordCriteria {
  valid: boolean;
  message: string;
}

@Component({
  selector: 'app-input-psw-criteria',
  templateUrl: './input-psw-criteria.component.html',
  styleUrls: ['./input-psw-criteria.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputPswCriteriaComponent),
      multi: true,
    },
  ],
})
export class InputPswCriteriaComponent {
  @Input() type: string = 'text';
  @Input() placeholder: string = '';
  @Input() label: string = '';
  @Input() formControl: FormControl = new FormControl('');
  @Input() formControlName: string = '';
  @Input() obscure: boolean = false;
  @Input() outline?: boolean = false;
  @Input() isClearable?: boolean = false;
  @Input() hint?: string = '';
  @Input() errorMessages: { [key: string]: string } = {};
  @Input() criteriaList: PasswordCriteria[] = [];
  @Output() enterPressed: EventEmitter<void> = new EventEmitter<void>();
  @Output() handleReset: EventEmitter<void> = new EventEmitter<void>();

  hide = false;

  value: any = '';

  onChange: any = () => {};
  onTouched: any = () => {};

  control!: FormControl;

  private _isDisabled = false;

  @Input() set isDisabled(value: boolean) {
    this._isDisabled = value;
    if (this.control) {
      if (value) {
        this.control.disable();
      } else {
        this.control.enable();
      }
    }
  }

  matcher = new FieldErrorStateMatcher();

  constructor(@Optional() private controlContainer: ControlContainer) {}

  errorKeys(): string[] {
    if (!this.control || (!this.control.touched && !this.control.dirty)) {
      return [];
    }
    return Object.keys(this.errorMessages).filter((key) =>
      this.control.hasError(key)
    );
  }

  ngOnInit() {
    if (this.formControl) {
      this.control = this.formControl;
    }

    if (this.controlContainer && this.formControlName) {
      const form = this.controlContainer.control as any;
      this.control = form.get(this.formControlName) as FormControl;
    }

    if (this._isDisabled) {
      this.control?.disable();
    }
  }

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    // this.disabled = isDisabled;
  }

  onInput(event: any) {
    this.value = event.target.value;
    this.onChange(this.value);
  }

  clickObscureEvent(event: MouseEvent) {
    event.preventDefault();
    this.hide = !this.hide;
    event.stopPropagation();
  }

  onEnter(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      event.preventDefault();
      this.enterPressed.emit();
    }
  }

  handleInnerReset(event: MouseEvent) {
    event.stopPropagation();
    event.preventDefault();
    this.value = '';
    this.handleReset.emit();
  }

  getProgress(): number {
    if (!this.criteriaList || this.criteriaList.length === 0) {
      return 0;
    }

    const validCount = this.criteriaList.filter((c) => c.valid).length;
    return (validCount / this.criteriaList.length) * 100;
  }

  onButtonclickPswCriteria(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
  }
}
